import { Outlet } from "react-router";
import React from "react";
import { Stack, styled } from "@mui/material";
import { Footer } from "./Footer";
import PageSuspense from "routes/PageSuspense";
import LogoutUI from "components/LogoutUI";
import { Box } from "@mui/system";

const Container = styled(Stack)(({ theme }) => ({
  height: "calc(((1 - var(--template-frame-height, 0)) * 100dvh) - 60px)",
  minHeight: "100%",
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  paddingLeft: theme.spacing(0),
  paddingRight: theme.spacing(0),
  [theme.breakpoints.up("sm")]: {
    padding: theme.spacing(4),
  },
  "&::before": {
    content: '""',
    display: "block",
    position: "absolute",
    zIndex: -1,
    inset: 0,
    backgroundColor: "#f4f4f5",
    padding: {
      sm: 0,
    },
  },
}));

const External = () => {
  return (
    <React.Fragment>
      <Container direction="column" sx={{ justifyContent: "space-between" }}>
        <Box
          sx={{
            position: "absolute",
            right: 20,
            top: 20,
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <LogoutUI showName />
        </Box>
        <PageSuspense>
          <Outlet />
        </PageSuspense>
      </Container>
      <Footer />
    </React.Fragment>
  );
};

export default External;
